jQuery('body').on('click', '.js-woo-notice-dismiss', function() {
	var $notice = jQuery(this).closest('.woocommerce-message, .woocommerce-error, .woocommerce-info');
	$notice.slideUp(300, function() {
		$notice.remove();
	});
});

/**
 * Hide cart query-param, which is used purely for cache purposes
 */
const ready = (fn) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
};
ready(() => {
  const url = new URL(window.location.href);

  if (url.searchParams.has('nocache')) {
    url.searchParams.delete('nocache');

    history.replaceState(
      history.state,
      document.title,
      url.pathname + url.search + url.hash
    );
  }
});